import { useState } from "react";
import { ChevronDown } from "lucide-react";

const STEPS = [
  ["Name", "Pick a name, ticker and theme — or let AI brainstorm."],
  ["Logo", "AI draws a logo and tagline. Re-roll until it's right."],
  ["Whitepaper", "AI writes vision, utility, tokenomics and roadmap."],
  ["Publish", "$19 once for a live page and share card. Mint on Solana later."],
];

/** One-line summary that expands — keeps the name field above the fold on phones. */
export default function HowItWorks() {
  const [open, setOpen] = useState(false);
  return (
    <div className="mb-6 border border-[#3a3a3a] bg-[#111]" data-testid="how-it-works">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="how-it-works-toggle"
        aria-expanded={open}
        className="w-full flex items-center justify-between gap-3 px-5 py-3 text-left"
      >
        <span className="text-sm text-[#e2e2e2]">
          <span className="text-[#cfff04] font-semibold">4 steps, ~10 minutes.</span> Free to draft — you only pay when you publish.
        </span>
        <ChevronDown size={16} className={`flex-shrink-0 text-[#d0d0d0] transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ol className="grid grid-cols-1 sm:grid-cols-4 gap-4 px-5 pb-5 text-sm" data-testid="how-it-works-steps">
          {STEPS.map(([t, d], i) => (
            <li key={t}>
              <div className="font-display font-bold text-base text-white">{i + 1}. {t}</div>
              <div className="text-[#c4c4c4] mt-1">{d}</div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
